import { OfferingDefinitionGetResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

const config = {
  staleTime: 60000,
  refetchOnWindowFocus: false,
};

export const useOffering = (offeringId: string | undefined) => {
  const client = useClient();
  const result = useQuery<OfferingDefinitionGetResponse, Error>({
    queryKey: ['offering', { offeringId }],
    queryFn: () => client.get(`offering/${offeringId}`).json<OfferingDefinitionGetResponse>(),
    enabled: !!offeringId,
    ...config,
  });
  return { ...result, offering: result.data };
};
